import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    padding: 12,
  },
  section: {
    flexDirection: "column",
    flexGrow: 1,
    border: 1,
    display: "flex",
  },
  headertext: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    borderBottom: 1,
    width: "100%",
    padding: 6,
  },
  title: {
    fontWeight: "bolder",
    fontSize: 15,
    textAlign: "center",
    width: "100%",
    marginBottom: 9,
  },
  companyaddress: {
    fontSize: 10,
    textAlign: "center",
    width: "100%",
    marginBottom: 7,
  },
  producthead: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    borderBottom: 1,
  },
  producttitle: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    borderBottom: 1,
  },
  productbody: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
  },
  no: { width: "6%", borderRight: 1, padding: 5 },
  enquiryNo: { width: "12%", borderRight: 1, padding: 5 },
  taxinvoiceNo: { width: "12%", borderRight: 1, padding: 5 },
  customerName: { width: "17%", borderRight: 1, padding: 5 },
  phone: { width: "13%", borderRight: 1, padding: 5 },
  products: { width: "20%", borderRight: 1, padding: 5 },
  quantity: { width: "8%", borderRight: 1, padding: 5 },
  total: { width: "10%", borderRight: 1, padding: 5 },
  status: { width: "14%", padding: 5 }, // ✅ new column
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 9,
    fontFamily: "Times-Roman",
    padding: 6,
  },
  lastpage: {
    display: "flex",
    flexDirection: "row",
    marginTop: 7,
    marginBottom: 20,
    justifyContent: "flex-end",
  },
  totaledit: { fontSize: 10, fontWeight: "bolder", marginRight: 20 },
  suptotal: { fontSize: 10, fontWeight: "bolder", marginRight: 20 },
});

const ITEMS_PER_PAGE = 30; // reduced to fit new column

const OnlineSalesPDF = ({ data, fromdate, todate }) => {
  const subTotal = data.reduce(
    (acc, item) => acc + parseFloat(item.discount_total || 0),
    0
  );

  // ✅ map status
  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Confirmed";
      case 2:
        return "Packing";
      case 3:
        return "Delivered";
      case 4:
        return "Rejected";
      default:
        return "Waiting for confirmation";
    }
  };

  const chunkData = (data, size) => {
    const chunkedArray = [];
    for (let i = 0; i < data.length; i += size) {
      chunkedArray.push(data.slice(i, i + size));
    }
    return chunkedArray;
  };

  const pages = chunkData(data, ITEMS_PER_PAGE);
  const totalPages = pages.length;
  const formattedFromDate = moment(fromdate).format("DD-MM-YYYY");
  const formattedToDate = moment(todate).format("DD-MM-YYYY");

  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page
          size="A4"
          orientation="landscape"
          style={styles.page}
          key={pageIndex}
        >
          <View style={styles.section}>
            <View style={styles.headertext}>
              <Text style={styles.title}>Online Sales Report</Text>
              <Text style={styles.companyaddress}>
                {formattedFromDate !== "Invalid date" &&
                formattedToDate !== "Invalid date"
                  ? `From ${formattedFromDate} To ${formattedToDate}`
                  : "All Online Enquiries"}
              </Text>
            </View>

            {/* Table header */}
            <View style={styles.producthead}>
              <View style={styles.producttitle}>
                <Text style={styles.no}>S No</Text>
                <Text style={styles.enquiryNo}>Enquiry No</Text>
                <Text style={styles.taxinvoiceNo}>Tax Invoice No</Text>
                <Text style={styles.customerName}>Customer Name</Text>
                <Text style={styles.phone}>Phone</Text>
                {/* <Text style={styles.products}>Products</Text> */}
                <Text style={styles.quantity}>Quantity</Text>
                <Text style={styles.total}>Total</Text>
                <Text style={styles.status}>Order Status</Text> {/* ✅ new */}
              </View>

              {/* Table body */}
              <View style={styles.bodydescription}>
                {pageData.map((item, index) => {
                  const products = item.products || [];
                  const totalQty = products.reduce(
                    (sum, p) => sum + parseInt(p.qty || 0),
                    0
                  );
                  return (
                    <View style={styles.productbody} key={index}>
                      <Text style={styles.no}>
                        {pageIndex * ITEMS_PER_PAGE + index + 1}
                      </Text>
                      <Text style={styles.enquiryNo}>
                        {item.enquiry_no || "N/A"}
                      </Text>
                      <Text style={styles.taxinvoiceNo}>
                        {item.tax_invoice_no || "N/A"}
                      </Text>
                      <Text style={styles.customerName}>
                        {item.customer_name || "N/A"}
                      </Text>
                      <Text style={styles.phone}>{item.phone || "N/A"}</Text>
                      {/* <Text style={styles.products}>
                        {products.map((p) => p.product_name).join(", ") ||
                          "N/A"}
                      </Text> */}
                      <Text style={styles.quantity}>{totalQty}</Text>
                      <Text style={styles.total}>
                        {item.discount_total || 0}
                      </Text>
                      <Text style={styles.status}>
                        {getStatusText(item.status)}
                      </Text>{" "}
                      {/* ✅ */}
                    </View>
                  );
                })}
              </View>
            </View>

            {/* Show total only on last page */}
            {pageIndex === totalPages - 1 && (
              <View style={styles.lastpage}>
                <Text style={styles.totaledit}>Total</Text>
                <Text style={styles.suptotal}>{subTotal.toFixed(2)}</Text>
              </View>
            )}
          </View>

          {/* Footer */}
          <Text style={styles.footer}>
            Page {pageIndex + 1} of {totalPages}
          </Text>
        </Page>
      ))}
    </Document>
  );
};

export default OnlineSalesPDF;
